// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('bspSetup', {
//         templateUrl: 'views/components/views/bspSetup/bspSetup.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['modalService', 'translateService', 'bspSetupService', function (modalService, translateService, bspSetupService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;

//             let translations = {
//                 confirm_title: '',
//                 confirm_message: '',
//                 do_you_really_want_to_reset_usergroups: '',
//                 do_you_really_want_to_nulldata: '',
//                 confirm_ok_label: '',
//                 confirm_cancel_label: '',
//                 error: '',
//                 ok: ''
//             };

//             vm.model = {
//                 edit: {},
//                 selectListBsps: [],
//                 lockedExecute: false,
//                 lockedRollback: false,
//                 lockedReset: false,
//                 lockedNullData: false,
//                 resetingData: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATE SERVICE

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATE SERVICE

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await bspSetupService.getEdit())[0];
//             }

//             async function loadBsps() {
//                 vm.model.selectListBsps = (await bspSetupService.listBsps());
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.executeChanges = function () {
//                 vm.model.lockedExecute = true;

//                 bspSetupService.executeObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                     	modalService.show({
//                     		type: 'warning',
//                     		title: translations.error,
//                     		message: response[0].errormessage,
//                     		buttons: [{
//                     			label: translations.ok,
//                     			cssClass: 'btn-warning',
//                     			action: function (dialogItself) {
//                     				dialogItself.close();
//                     				vm.model.lockedExecute = false;
//                     			}
//                     		}]
//                     	});
//                     } else {
//                     	vm.model.lockedExecute = false;
//                         window.location.reload(true);
//                     }
//                 });
//             };

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region BUTTON ROLLBACK PROCEDURE FUNCTION CALL

//             vm.rollbackValues = function () {
//                 vm.model.lockedRollback = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     bspSetupService.rollbackItem(vm.model.edit).then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                         	modalService.show({
//                         		type: 'warning',
//                         		title: translations.error,
//                         		message: response[0].errormessage,
//                         		buttons: [{
//                         			label: translations.ok,
//                         			cssClass: 'btn-warning',
//                         			action: function (dialogItself) {
//                         				dialogItself.close();
//                         				vm.model.lockedRollback = false;
//                         			}
//                         		}]
//                         	});
//                         } else {
//                         	vm.model.lockedRollback = false;
//                             window.location.reload(true);
//                         }
//                     }, function () {
//                         vm.model.lockedRollback = false;
//                     });
//                 }, function () {
//                     vm.model.lockedRollback = false;
//                 });
//             };

//             // #endregion BUTTON ROLLBACK PROCEDURE FUNCTION CALL

//             // #region BUTTON RESET PROCEDURE FUNCTION CALL

//             vm.resetValues = function () {
//                 vm.model.lockedReset = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.do_you_really_want_to_reset_usergroups,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     bspSetupService.resetItem().then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                         	modalService.show({
//                         		type: 'warning',
//                         		title: translations.error,
//                         		message: response[0].errormessage,
//                         		buttons: [{
//                         			label: translations.ok,
//                         			cssClass: 'btn-warning',
//                         			action: function (dialogItself) {
//                         				dialogItself.close();
//                         				vm.model.lockedReset = false;
//                         			}
//                         		}]
//                         	});
//                         } else {
//                             vm.model.lockedReset = false;
//                             loadEdit();
//                         }
//                     }, function () {
//                         vm.model.lockedReset = false;
//                     });
//                 }, function () {
//                     vm.model.lockedReset = false;
//                 });
//             };

//             // #endregion BUTTON RESET PROCEDURE FUNCTION CALL

//             // #region BUTTON NULL DATA PROCEDURE FUNCTION CALL

//             vm.nullDataValues = function () {
//                 vm.model.lockedNullData = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.do_you_really_want_to_nulldata,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(function () {
//                     bspSetupService.nullDataItem().then(function (response) {
//                         if (response[0].errorcode !== '0') {
//                         	modalService.show({
//                         		type: 'warning',
//                         		title: translations.error,
//                         		message: response[0].errormessage,
//                         		buttons: [{
//                         			label: translations.ok,
//                         			cssClass: 'btn-warning',
//                         			action: function (dialogItself) {
//                         				dialogItself.close();
//                                         vm.model.lockedNullData = false;
//                         			}
//                         		}]
//                         	});
//                         } else {
//                             vm.model.lockedNullData = false;
//                             window.location.reload(true);
//                         }
//                     }, function () {
//                         vm.model.lockedNullData = false;
//                     });
//                 }, function () {
//                     vm.model.lockedNullData = false;
//                 });
//             };

//             // #endregion BUTTON NULL DATA PROCEDURE FUNCTION CALL

//             // #region BUTTON RESET TRANSACTION DATA PROCEDURE FUNCTION CALL

//             vm.resetDataChanges = function () {
//                 vm.model.resetingData = true;

//                 modalService.confirm({
//                     type: 'danger',
//                     title: translations.confirm_title,
//                     message: translations.confirm_message,
//                     okLabel: translations.confirm_ok_label,
//                     cancelLabel: translations.confirm_cancel_label
//                 }).then(() => {
//                     bspSetupService.resetTransactionData(vm.model.edit).then((response) => {
//                         if (response[0] && response[0].errorcode !== '0') {
//                             modalService.show({
//                                 type: 'warning',
//                                 title: translations.error,
//                                 message: response[0].errormessage,
//                                 buttons: [{
//                                     label: translations.ok,
//                                     cssClass: 'btn-warning',
//                                     action: (dialogItself) => {
//                                         dialogItself.close();
//                                         vm.model.resetingData = false;
//                                     }
//                                 }]
//                             });
//                         } else {
//                             vm.model.resetingData = false;
//                         }
//                     }, () => vm.model.resetingData = false);
//                 }, () => vm.model.resetingData = false);
//             }

//             // #endregion BUTTON RESET TRANSACTION DATA PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = function () {
//                 translate();
//             	loadEdit();
//                 loadBsps();
//             };

//             // #endregion ON INIT FUNCTION
//         }]
//     });
// })();
